// extracted by mini-css-extract-plugin
export default {"dataGrid":"accounts_dataGrid__XmPuD","farmList":"accounts_farmList__tXwFM"};